import * as React from "react"
import {
    Box,
    Text,
    VStack,
    Code,
    Grid,
    theme,
} from "@chakra-ui/react"
import { ColorModeSwitcher } from "./ColorModeSwitcher"
import { Logo } from "./Logo"
import { Button, ButtonGroup, Heading } from "@chakra-ui/react"
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Switch, Center } from "@chakra-ui/react"

const Column = styled.div`
    text-align: center;
`

const Bar = styled.div`
    margin-top: 1vh;
    margin-bottom: 1vh;
`

const Rim = styled.div`
    border-style: solid;
    margin-top: 5vh;
`

const bstyle = {
    backgrounColor: '#4c4c4c',
}

const TP = styled.span`
    margin-left: 1vw;
`

const FarTravel = () => (
    <Box fontSize="xl">
        <Rim>
            <Grid minH="100vh" p={3}>

                <Bar>
                    <Column>
                        <Heading as="h2" size="lg">How far are you willing to travel?</Heading>
                    </Column>
                    <Center>
                        <div>
                            <Bar>
                                <p>Select all that apply.</p>
                            </Bar>
                            <Bar>
                                <p><Switch size="md" marginLeft="1rem" colorScheme="green" /><TP>In state</TP></p>
                                <p><Switch size="md" marginLeft="1rem" colorScheme="green" /><TP>In country</TP></p>
                                <p><Switch size="md" marginLeft="1rem" colorScheme="green" /><TP>In anywhere</TP></p>
                            </Bar>
                            <Bar>
                                <Link to="/fullyvaxx"><Button width="200px" colorScheme="teal">Continue</Button></Link>
                            </Bar>
                        </div>
                    </Center>
                </Bar>
                <Bar>
                    <Column>

                    </Column>
                </Bar>

            </Grid>
        </Rim>
    </Box>
)

export default FarTravel;
